import { EndCustomerDto } from '@gtpl/shared-models/masters';
import { DomesticSaleDetailedViewReq, DomesticSalesFilterRequest, DomesticSalesReqDto } from '@gtpl/shared-models/sale-management';
import { EndCustomersService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Button, Card, Col, Form, Input, Modal, Row, Select, Table } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import {EyeOutlined} from '@ant-design/icons'
import { ColumnProps } from 'antd/lib/table';
import moment from 'moment';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, UndoOutlined } from "@ant-design/icons";



const DomesticSalesView = () => {


    const saleOrderService = new SaleOrderService();
    const [domesticSalesDataForView, setDomesticSalesDataForView] = useState([]);
    const [endcustomersData, setendcustomersData] = useState<EndCustomerDto[]>([]);
    const [productsData, setProductsData] = useState<any[]>([]);
    const [unitData, setUnitData] = useState<any[]>([]);
    const [itemsInfo,setItemsInfo] = useState<DomesticSalesReqDto>( )
    const [modalOpen,setModalOpen] = useState<boolean>(false)
    const [page,setPage] = useState<number>(1) 
    const salOrderService = new SaleOrderService();
    const [domesticSalesView, setDomesticSalesView] = useState<any>();
    const {Option}=Select;
    const [form] = Form.useForm();
    const role = JSON.parse(localStorage.getItem('role'))
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);


    useEffect(() => {
       getData();
        getEndCustomersData();
        getAllProductsData();
        getAllUnits();
    }, []);


    const getEndCustomersData = () => {
        saleOrderService.getEndCustomersData().then((res) => {
          if (res.status) {
            setendcustomersData(res.data);
          } else {
            setendcustomersData([]);
          }
        }).catch((err) => {
          AlertMessages.getErrorMessage(err.message);
          setendcustomersData([]);
        });
      }

      const getAllProductsData = () => {
        saleOrderService.getAllProducts().then((res) => {
          if (res.status) {
            setProductsData(res.data);
          } else {
            setProductsData([]);
          }
        }).catch((err) => {
          AlertMessages.getErrorMessage(err.message);
          setProductsData([]);
        });
      }

      const getAllUnits = () => {
        saleOrderService.getAllUnits().then((res) => {
          if (res.status) {
            setUnitData(res.data);
          } else {
            setUnitData([]);
          }
        }).catch((err) => {
          AlertMessages.getErrorMessage(err.message);
          setUnitData([]);
        });
      }


    const getData = () => {
        const req = new DomesticSalesFilterRequest()
        if (form.getFieldValue('endCustomerId') !== undefined) {
          req.endCustomerId = form.getFieldValue('endCustomerId')
        }
        if (form.getFieldValue('productName') !== undefined) {
          req.productName = form.getFieldValue('productName')
        }
        if (form.getFieldValue('unitId') !== undefined) {
          req.unitId = form.getFieldValue('unitId')
        }
        const loggedInRole = JSON.parse(localStorage.getItem('role'));
        const loggedInUnitId = Number(localStorage.getItem('unit_id'));
    
        if (loggedInRole !== 'SUPERADMIN') {
          req.unitId = loggedInUnitId // Convert number to string
      }
        saleOrderService.getDomesticSalesDataInView(req).then(res => {
            if (res.status) {
                setDomesticSalesDataForView(res.data);
            } else {
              setDomesticSalesDataForView([])
                AlertMessages.getErrorMessage(res.internalMessage);
            }
        })
    };

    const onReset = () => {
      form.resetFields();
      getData();
    };



    const detailViewHandler = (rowData) => {
        console.log(rowData,"rowdattttttttaaaaaaaaaaaa")
        // setItemsInfo(rowData.)
        getDomesticSalesDetailedView(rowData.domesticSaleOrderNo)
        setModalOpen(true)
    }


  
  
    const getDomesticSalesDetailedView = (domesticSaleOrderNo) => {
      // const req=new SoFormSdfPrintDto()
      salOrderService.getDomesticSalesDetailedView(new DomesticSaleDetailedViewReq(domesticSaleOrderNo)).then((res) => {
        console.log(res,"resssssssssssssssssssssss")
        if (res.status) {
          setDomesticSalesView(res.data);
        }
      });
    };


    function handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
  };
  function handleReset(clearFilters) {
      clearFilters();
      setSearchText('');
  };
  const getColumnSearchProps = (dataIndex: string) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
              <Input
                  ref={searchInput}
                  placeholder={`Search ${dataIndex}`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
              />
              <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
              >
                  Search
              </Button>
              <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  Reset
              </Button>
          </div>
      ),
      filterIcon: filtered => (
          <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value, record) =>
          record[dataIndex]
              ? record[dataIndex]
                  .toString()
                  .toLowerCase()
                  .includes(value.toLowerCase())
              : false,
      onFilterDropdownVisibleChange: visible => {
          if (visible) { setTimeout(() => searchInput.current.select()); }
      },
      render: text =>
          text ? (
              searchedColumn === dataIndex ? (
                  <Highlighter
                      highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                      searchWords={[searchText]}
                      autoEscape
                      textToHighlight={text.toString()}
                  />
              ) : text
          ) : null
  });


    const itemColumns : ColumnProps<any>[] = [
        {
            title: 'S No',
            key: 'sno',
            width: '70px',
            responsive: ['sm'],
            render: (text, object, index) => (page - 1) * 10 + (index + 1)
        },

        {
            title:'Location',
            dataIndex:'locationName',
            ...getColumnSearchProps('locationName')
        },
        {
            title:'Cases',
            dataIndex:'cases',
            ...getColumnSearchProps('cases')
        },
        {
            title:'LoosePouches',
            dataIndex:'loosePouches',
            ...getColumnSearchProps('loosePouches')
        },
        {
          title: "Unit Price",
          dataIndex: "unitPrice",
          ...getColumnSearchProps('unitPrice')
      },
      {
          title: "Tax",
          dataIndex: "tax",
          render: (text) => `${text}%`,
          ...getColumnSearchProps('tax')
      },
        {
            title:'Quantity',
            dataIndex:'quantity',
            // render: (text) => parseFloat(text).toFixed(2).replace(/\.?0+$/, '')
            render: (text) => {
              const indianFormattedNumber = parseFloat(text).toLocaleString('en-IN');
              const formattedText = parseFloat(text).toFixed(2).replace(/\.?0+$/, '');
              return (
                <>
                  <div>{indianFormattedNumber}</div>
                  {/* <div>{formattedText}</div> */}
                </>
              );
            }
        },
        {
          title: "Company",
          dataIndex: "company",
          ...getColumnSearchProps('company')

        },

    ]
    

    const Columns : ColumnProps<any>[]  = [
      {
        title: 'S No',
        key: 'sno',
        width: '70px',
        responsive: ['sm'],
        render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
      title: "Sale Number",
      dataIndex: "domesticSaleOrderNo",
      ...getColumnSearchProps('domesticSaleOrderNo')

  },
        {
            title: "Product",
            dataIndex: "productName",
            ...getColumnSearchProps('productName'),
            sorter: (a, b) => a.productName?.localeCompare(b.productName),
            sortDirections: ['descend', 'ascend'],

        },
        {
          title: "Customer",
          dataIndex: "customerName",
          ...getColumnSearchProps('customerName'),
          sorter: (a, b) => a.customerName?.localeCompare(b.customerName),
          sortDirections: ['descend', 'ascend'],

      },
        {
            title: "Pack Style",
            dataIndex: "packStyleName",
            ...getColumnSearchProps('packStyleName'),
            sorter: (a, b) => a.packStyleName?.localeCompare(b.packStyleName),
            sortDirections: ['descend', 'ascend'],

        },

        {
            title: "Cases",
            dataIndex: "cases",
            sorter: (a, b) => a.cases?.localeCompare(b.cases),
            sortDirections: ['descend', 'ascend'],

        },
        {
            title: "Loose Pouches",
            dataIndex: "loosePouches",
            sorter: (a, b) => a.loosePouches?.localeCompare(b.loosePouches),
            sortDirections: ['descend', 'ascend'],

        },
        {
            title: "Quantity (In Kgs)",
            dataIndex: "quantity",
            sorter: (a, b) => a.quantity?.localeCompare(b.quantity),
            sortDirections: ['descend', 'ascend'],
            render: (text) => {
              const indianFormattedNumber = parseFloat(text).toLocaleString('en-IN');
              const formattedText = parseFloat(text).toFixed(2).replace(/\.?0+$/, '');
              return (
                <>
                  <div>{indianFormattedNumber}</div>
                  {/* <div>{formattedText}</div> */}
                </>
              );
            }
          },
 
        {
            title: "Total Amount",
            dataIndex: "amount",
            // render: (text) => parseFloat(text).toFixed(2).replace(/\.?0+$/, '')
            render: (text) => {
              const indianFormattedNumber = parseFloat(text).toLocaleString('en-IN');
              const formattedText = parseFloat(text).toFixed(2).replace(/\.?0+$/, '');
              return (
                <>
                  <div>{indianFormattedNumber}</div>
                  {/* <div>{formattedText}</div> */}
                </>
              );
            },
            ...getColumnSearchProps('amount'),
            sorter: (a, b) => a.amount?.localeCompare(b.amount),
            sortDirections: ['descend', 'ascend'],

        },
        {
            title: "Unit",
            dataIndex: "unitName",
            ...getColumnSearchProps('unitName')

        },
        {
          title: "Sale Date",
          dataIndex: "saleOrderDate",
          width:"90px",
          ...getColumnSearchProps('saleOrderDate'),
          sorter: (a, b) => a.saleOrderDate?.localeCompare(b.saleOrderDate),
          sortDirections: ['descend', 'ascend'],

          render: (value,  record) => {
            return moment(record.saleOrderDate).format('YYYY-MM-DD');
          },
          
        },
        {
            title: "Action",
            render:(text,record) => {
                return(
                    <span>                      
                        <Button onClick={() => detailViewHandler(record)}><EyeOutlined/></Button>
                    </span>
                )
            }
            }
    
    ];

  return (
    <div>
        <Card title={<span style={{ color: 'white' }}>Domestic Sales View</span>}  style={{ textAlign: "center" }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
             extra={
                <Link to="/domestic-sales">
                    <Button 
                        type="primary" 
                        style={{ background: "white", color: "#3C085C" }}
                    >
                        Create
                    </Button>
                </Link>
            }
            >
                <Form form={form} onFinish={getData} layout='vertical'>
                    <Row gutter={18}>
                    <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 4}} lg={{ span: 8}} xl={{ span: 5}}>
                    <Form.Item label="Customer" name="endCustomerId">
                    <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select  customer"
                allowClear
                >
                {endcustomersData.map(dropData => {
                  return <Option value={dropData.endCustomerId}>{dropData.endCustomerName}</Option>
                })}
              </Select>
              </Form.Item>
                    </Col>  
                    <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 4}} lg={{ span: 8}} xl={{ span: 5}}>
                    <Form.Item label="Products" name="productName">
            <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Select Products"
                allowClear
            >
                {productsData.map(dropData => (
                    <Option key={dropData.skuCodeId} value={dropData.skuCodeId}>
                        {dropData.shortCode}
                    </Option>
                ))}
            </Select>
        </Form.Item>
                    </Col> 
                    <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 4}} lg={{ span: 8}} xl={{ span: 5}}>
    <Form.Item label="Unit" name="unitId">
        <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            placeholder="Select  Unit"
            allowClear
            // style={{ width: '100%', maxWidth: '300px' }}  // Fixed width with a max width
            disabled={Number(localStorage.getItem('unit_id')) != 5 ? true : false}
            defaultValue={role == 'SUPERADMIN' ? 'all' : Number(localStorage.getItem('unit_id'))}
        >
            {unitData.map(dropData => {
                return <Option value={dropData.unitCodeId}>{dropData.plantCode}</Option>
            })}
        </Select>
    </Form.Item>
</Col>
<Col xs={12} sm={6} md={4} lg={3} xl={2} style={{paddingTop:"25px"}}>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                style={{ background: "green", width: "100%" }}
              >
                Search
              </Button>
            </Form.Item>
          </Col>
          <Col xs={12} sm={6} md={4} lg={3} xl={2} style={{paddingTop:"25px"}}>
            <Form.Item>
              <Button
                danger
                // icon={<UndoOutlined />}
                onClick={onReset}
                style={{ width: "100%" }}
              >
                Reset
              </Button>
            </Form.Item>
          </Col>
</Row><Row gutter={8}>
                   
                    </Row>
                </Form>
        <Table columns={Columns} dataSource={domesticSalesDataForView} scroll={{x:true}}/>
        <Modal visible={modalOpen} onCancel={() => setModalOpen(false)} width={'80%'} footer={[]}>
                <Table columns={itemColumns} dataSource={domesticSalesView} pagination={false}/>
            </Modal>
        </Card>
    </div>
  )
}

export default DomesticSalesView